import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a630b9f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute inset-0 drop-shadow-[0_0_22px_rgba(255,122,47,0.85)]" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "absolute inset-0 drop-shadow-[0_0_10px_rgba(255,200,120,0.95)]" }
const _hoisted_5 = ["src", "alt"]

import { onBeforeUnmount, onMounted, ref } from "vue";

// La escultura se "cuela": el metal fundido llena la figura de arriba hacia
// abajo y se enfría de naranja incandescente a su color metálico real.
const POUR_MS = 2800;
const COOL_LAG_MS = 1000;
const COOL_MS = 2200;


export default /*#__PURE__*/_defineComponent({
  __name: 'SculpturePour',
  props: {
  src: { type: String, required: true },
  alt: { type: String, default: "" },
  startDelay: { type: Number, default: 500 },
},
  emits: ["pouring"],
  setup(__props, { emit }) {

const props = __props;




const img = ref<HTMLImageElement | null>(null);
const fill = ref(0);
const cool = ref(0);
const done = ref(false);

let frame = 0;
let timer = 0;

const easeInOut = (t: number) =>
  t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
const clamp = (t: number) => Math.min(1, Math.max(0, t));

const finish = () => {
  fill.value = 100;
  cool.value = 112;
  done.value = true;
  emit("pouring", false);
};

const run = () => {
  emit("pouring", true);
  const t0 = performance.now();
  const tick = (now: number) => {
    const elapsed = now - t0;
    // La figura empieza un poco debajo del borde superior de la caja
    fill.value = 4 + easeInOut(clamp(elapsed / POUR_MS)) * 100;
    cool.value = easeInOut(clamp((elapsed - COOL_LAG_MS) / COOL_MS)) * 112;
    if (elapsed < COOL_LAG_MS + COOL_MS) frame = requestAnimationFrame(tick);
    else finish();
  };
  frame = requestAnimationFrame(tick);
};

onMounted(() => {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches)
    return finish();
  timer = window.setTimeout(run, props.startDelay);
});

onBeforeUnmount(() => {
  cancelAnimationFrame(frame);
  clearTimeout(timer);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "relative h-full w-full animate-float drop-shadow-[0_24px_30px_rgba(0,0,0,0.8)]",
    style: _normalizeStyle({ '--fill': `${fill.value}%`, '--cool': `${cool.value}%` })
  }, [
    (!done.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("img", {
              src: __props.src,
              alt: "",
              class: "layer hot-mask hot-metal"
            }, null, 8, _hoisted_2)
          ]),
          _createElementVNode("img", {
            src: __props.src,
            alt: "",
            class: "layer cool-mask"
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", {
              class: "layer surface",
              style: _normalizeStyle({ '--shape': `url(${__props.src})` })
            }, null, 4)
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createElementVNode("img", {
      ref_key: "img",
      ref: img,
      src: __props.src,
      alt: __props.alt,
      class: _normalizeClass(["layer", { invisible: !done.value }])
    }, null, 10, _hoisted_5)
  ], 4))
}
}

})